import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

import DateFormat from '../../constants/dateFormat'
import i18n from '../../locales/i18n'
import moment from '../../momentLocale'

// default sizes for consistent setting initial signature
export const SIGNATURE_DRAWER_WIDTH = 560
export const SIGNATURE_DRAWER_HEIGHT = 180

const signatureSlotRegexp = /(<table class="SIGNATURE".*?><\/table>)/
export const containsSignatureSlot = (str: string) => {
  signatureSlotRegexp.lastIndex = 0
  return signatureSlotRegexp.test(str)
}

export const addSignatureToDocumentBody = (
  body: string,
  options: { clientName: string; signatureString: string },
) => {
  const { clientName, signatureString } = options || {}
  const signedAt = moment().format(DateFormat.FULL_DATE_TIME)

  const confirmedSignatureString = (
    <td
      className="SIGNATURE_signed"
      style={{ width: 200, border: '1px solid #EDECEC' }}
    >
      <img alt="signature_img" src={signatureString} width={200} />
    </td>
  )

  const signAttributesString = (
    <span
      style={{
        fontSize: '0.65em',
        opacity: 0.5,
        marginTop: '0.8em',
        display: 'block',
      }}
    >
      {i18n.t<string>('Common:SIGNATURE.SIGNED_AT_DATE_BY_CLIENT', {
        signedAt,
        clientName,
      })}
    </span>
  )

  const signatureLabel = (
    <td
      className="SIGNATURE_label"
      style={{ border: '1px solid #EDECEC', padding: 8 }}
    >
      {i18n.t<string>('Common:SIGNATURE.LABEL')}
    </td>
  )

  const signedSignatureSlot = (
    <>
      <table
        className="SIGNATURE_SIGNED"
        style={{ borderCollapse: 'collapse' }}
      >
        <tr>
          {signatureLabel}
          {confirmedSignatureString}
        </tr>
      </table>
      {signAttributesString}
    </>
  )

  return body.replace(
    new RegExp(signatureSlotRegexp, 'g'),
    renderToStaticMarkup(signedSignatureSlot),
  )
}
